import Query from '../../../components/Report';

const query = (directory, subdomain) =>
    new Query('search-urls-directories-details-table', {
        directory,
        subdomain,
    });

export default query;
